import { gql, useQuery } from '@apollo/client'

export interface SupportedMarkCodeTypes {
  supportedMarkCodeTypes: []
}

export const GQL_QUERY_SUPPORTED_MARK_CODE_TYPES = gql`
  query {
    supportedMarkCodeTypes
  }
`

export const useFetchSupportedMarkCodeTypes = () => {
  return useQuery<SupportedMarkCodeTypes>(GQL_QUERY_SUPPORTED_MARK_CODE_TYPES)
}
